module.exports = __webpack_public_path__ + "static/media/cloud2.3e63443b.png";